import { LocationModel } from "app/services/api/types/authorisation/models/LocationModel";
import { View } from "ui/atoms/view";
import DetailCard from "ui/molecules/cards/DetailCard";
import { Text } from "react-native";
import { useMemo } from "react";

interface Props {
  location: LocationModel;
}

export function LocationDetailCard({ location }: Props) {
  const details = useMemo(() => {
    return [
      `${location.floors_count} floors`,
      `${location.rooms_count} rooms`,
      `${location.user_count} users`,
      `${location.residents_count} residents`,
    ];
  }, [location]);

  return (
    <View key={location.id} className="mb-7">
      <Text className="text-xs text-typography-500">
        Location {location.id}
      </Text>
      <DetailCard
        title={location.name}
        details={details}
        link={`/locations/${location.id}`}
      ></DetailCard>
    </View>
  );
}
